<template>
  <v-row class="d-flex justify-center mt-md-8">
    <v-col cols="12" sm="12" md="4">
      <v-card class="white rounded-lg login-card pa-5">
        <v-img class="white--text align-end mt-5" height="100px" contain src="/img/loginLogo.svg" alt="Login Logo" />
        <v-form @submit.prevent="login">
          <v-card-text class="text--primary">
            <v-text-field
              v-model="username"
              class="mt-4 rtl rounded-lg"
              dense
              outlined
              hide-details
              label="نام کاربری"
            />
            <v-text-field
              v-model="password"
              class="mt-3 rtl rounded-lg"
              dense
              outlined
              hide-details
              label="رمز عبور"
              type="password"
            />
          </v-card-text>

          <v-card-actions class="pb-3">
            <v-btn type="submit" block depressed class="primary white--text rounded-lg">
              ورود به پنل ادمین
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "Login",
  data() {
    return {
      username: "",
      password: "",
    };
  },
  mounted() {
    document.title = "ورود";
  },
methods: {
  login() {
    this.request({
      url: this.endpoint("sobhanAdmin/login"),
      method: "post",
      data: {
        username: this.username,
        password: this.password,
      },
      token: false,
      success: (data) => {
        this.setToken(data.token);

        this.request({
          url: this.endpoint("sobhanAdmin/currentAdmin/"),
          method: "get",
          token: true,
          success: (user) => {
            this.$store.commit("setUser", user);

            const redirectUrl = this.urlQuery.redirectUrl;
            if (redirectUrl) {
              this.$router.push(redirectUrl);
              return;
            }

            const allRoutes = [
              { title: "خانه", name: "Home", perm: "home_page" },
              { title: "کسب و کار ها", name: "CompaniesList", perm: "companies" },
              { title: "اپراتور ها", name: "AdminOperators", perm: "operators" },
              { title: "کاربران", name: "UsersList", perm: "users" },
              { title: "کد های معرف", name: "ReferralCodes", perm: "referral_codes" },
              { title: "تراکنش ها", name: "FactorsList", perm: "factors" },
              { title: "کد تخفیف", name: "DiscountCodesList", perm: "discounts" },
              { title: "افزونه و پکیج ها", name: "Packages", perm: "extensions" },
              { title: "حسابداری ابری", name: "CloudAccounting", perm: "cloud_accounting" },
            ];

            const firstAllowedRoute = allRoutes.find(r => user.permissions[r.perm]);
            this.$router.push({ name: firstAllowedRoute ? firstAllowedRoute.name : "Home" });
          },
        });
      },
    });
  },
},
};
</script>

<style scoped lang="scss">
.login-card {
  margin-top: 20%;
}

.rtl {
  direction: rtl;
}
</style>
